import axios from 'axios';

axios.defaults.withCredentials = true;

const API_URL = process.env.REACT_APP_API_URL;

// Hàm lấy dữ liệu xe từ API
const getVehicleData = async (source = 'Vtracking') => {
    try {
        const response = await axios.get(`${API_URL}/get_map_data?source=${source}`);
        return response.data.data;  // Trả về dữ liệu xe
    } catch (error) {
        console.error('Error fetching vehicle data:', error);
        throw new Error('Không thể lấy dữ liệu xe.');
    }
};

// Export tất cả các hàm dịch vụ
const VehicleService = {
    getVehicleData,
};

export default VehicleService;
